var codeblock_default = {
  "blockStyleSpacing": "xp8wO",
  "codeBlock": "SUnCl xp8wO",
  "renderedInTable": "ERFwH"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
